/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useEffect, useState } from "react";

import { Plate } from "src/classes/plate/Plate";
import { LoadingType, LoadingWrapper } from "src/components/Layout/LoadingWrapper";
import { PlateView } from "src/components/Plate/PlateView";
import { LoadingStatus } from "src/lib/types";

interface Props {
  username: string;
  pageSlug: string;
}

export function PlateFetcher({ username, pageSlug }: Props) {
  const [plate, setPlate] = useState<Plate | null>(null);
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.Idle);

  useEffect(() => {
    // due to some ssr bullshit or something these don't exist on first render
    if (!(pageSlug && username)) return;
    setLoadingStatus(LoadingStatus.Loading);
    Plate.load(username, pageSlug)
      .then((fetchedPlate) => {
        setPlate(fetchedPlate);
        setLoadingStatus(LoadingStatus.Succeeded);
      })
      .catch(() => {
        setLoadingStatus(LoadingStatus.Failed);
      });
  }, [pageSlug, username]);

  return (
    <LoadingWrapper status={loadingStatus} loadingType={LoadingType.Hidden}>
      <PlateView plate={plate!} key={pageSlug} />
    </LoadingWrapper>
  );
}
